export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11352.9284f5d5.jpg";